import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import Organisationsnummer from 'organisationsnummer';
import { Client } from '@ansvar-sakerhet/api-client';

export const customerInfoForm = z.object({
  name: z.string().min(1, 'Namn måste anges'),
  registrationNumber: z
    .string()
    .refine(
      (val) => val.trim() === '' || Organisationsnummer.valid(val),
      {
        message: 'Org.nr är inte giltigt',
      }
    ),
  policyLink: z.string().url('Ogiltig URL').or(z.literal('')).optional(),
});

export type customerInfoFormValues = z.infer<typeof customerInfoForm>;

export const useCustomerInfoForm = (client: Client) => {
  const methods = useForm<customerInfoFormValues>({
    mode: 'onTouched',
    resolver: zodResolver(customerInfoForm),
    defaultValues: {
      name: client.name ?? '',
      registrationNumber: client.registrationNumber ?? '',
      policyLink: client.policyLink ?? '',
    },
  });

  return methods;
};
